import { Helmet } from "react-helmet-async";
import { FACEBOOK_URL, INSTAGRAM_URL, TWITTER_URL } from "../../constants/links";
import { LEGAL_NAME, SITE_NAME, SITE_URL, SUPPORT_EMAIL, SUPPORT_PHONE } from "../../constants/site";

export default function HomeStructuredData() {
  const organizationId = `${SITE_URL}/#organization`;
  const southAfrica = { "@type": "Country", name: "South Africa" };

  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": organizationId,
        name: SITE_NAME,
        legalName: LEGAL_NAME,
        url: `${SITE_URL}/`,
        logo: `${SITE_URL}/logo512.png`,
        areaServed: southAfrica,
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer service",
          telephone: SUPPORT_PHONE,
          email: SUPPORT_EMAIL,
          areaServed: "ZA",
          availableLanguage: "English",
        },
        sameAs: [FACEBOOK_URL, TWITTER_URL, INSTAGRAM_URL],
      },
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        name: SITE_NAME,
        url: `${SITE_URL}/`,
        inLanguage: "en-ZA",
        publisher: { "@id": organizationId },
      },
      {
        "@type": "Service",
        name: "Parcel delivery",
        serviceType: "Courier and parcel delivery",
        description: "Affordable same-day and overnight parcel delivery across Gauteng and Limpopo, with online booking and parcel tracking.",
        url: `${SITE_URL}/`,
        provider: { "@id": organizationId },
        areaServed: southAfrica,
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
    </Helmet>
  );
}
